import { getBrowserUid } from '../browserUid';

const authHeader = (multipart = false) => {

    const token = localStorage.getItem('token')
    const headers = {
        "Content-Type": "application/json",
        "Accept": "*",
        "Access-Control-Expose-Headers": "Content-Disposition",
        "Authorization": `Bearer ${token}`,
        "X-Browser-Uid": getBrowserUid(),
    }

    if (multipart) {
        headers["Content-Type"] = "multipart/form-data";
    }
    return headers;
}

export default authHeader